import trans from 'translation';

export const getSearchField = (tabName: string) => {
  switch (tabName) {
    case trans('ar_overdue'):
      return [
        {
          key: trans('code'),
          label: trans('code'),
          name: 'code'
        },
        {
          key: trans('name'),
          label: trans('name'),
          name: 'name'
        },
        {
          key: trans('email'),
          label: trans('email'),
          name: 'email'
        },
        {
          key: trans('address'),
          label: trans('address'),
          name: 'address'
        },
        {
          key: trans('outstanding'),
          label: trans('outstanding'),
          name: 'outstanding'
        }
      ];
  }
  return [];
};
